import React, { Fragment } from 'react';
import Select from 'react-select';
import ReactHtmlParser from 'html-react-parser';
import { generateUUID } from '../../../../utils';
import Element from '../../../../components/element';
import Flex from '../../../../components/flex';
import { each } from 'lodash';

class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formItems: [{ selected: '', hideOther: true, other: '' }],
      isNone: false,
      changedState: false
    };
    this.handleDropdownChange = this.handleDropdownChange.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.onAddMore = this.onAddMore.bind(this);
    this.renderFormItems = this.renderFormItems.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
  }

  componentDidMount() {
    const { rawAnswers, storeAnswer, index } = this.props;
    if (rawAnswers) {
      this.setState(rawAnswers);
    } else {
      // storeAnswer(index, this.state);
    }
  }

  onAddMore() {
    if (this.state.isNone) return;

    let formItems = this.state.formItems;
    const { storeAnswer, questionId } = this.props;
    formItems.push({ selected: '', hideOther: true, other: '' });
    this.setState(
      {
        formItems,
        isNone: false,
        changedState: true
      },
      () => {
        storeAnswer(questionId, this.state, this.isQuestionAnswered());
      }
    );
  }

  handleTextChange(e, index, input) {
    const { storeAnswer, checkSurveyState } = this.props;
    let formItems = [...this.state.formItems];
    formItems[index][input] = e.target.value;
    this.setState(
      {
        formItems,
        isNone: false,
        changedState: true
      },
      () => {
        storeAnswer(this.props.index, this.state);
        checkSurveyState(this, true);
      }
    );
  }

  handleDropdownChange(e, index) {
    const { storeAnswer, questionId, checkRouteMap } = this.props;
    let formItems = [...this.state.formItems];
    if (!e.value) return;
    formItems[index].selected = e.value;

    if (
      e.value === 'Other (Please Specify)' ||
      e.value === 'Other Hot Cereal' ||
      e.value === 'Other Cold Cereal' ||
      e.value === 'Other'
    ) {
      formItems[index].hideOther = false;
    } else {
      formItems[index].hideOther = true;
    }
    this.setState(
      {
        formItems,
        isNone: false,
        changedState: true
      },
      () => {
        storeAnswer(questionId, this.state, this.isQuestionAnswered());
      }
    );
  }

  isQuestionAnswered = () => {
    let answered = false;
    each(this.state.formItems, item => {
      if (item.selected || item.other) {
        answered = true;
        return false;
      }
    });
    return answered;
  };

  deleteItem(index) {
    if (this.state.isNone) return;
    let formItems = this.state.formItems;
    formItems.splice(index, 1);
    this.setState({ formItems });
  }

  renderFormItems() {
    const { options, searchable, otherOption, label, size } = this.props;
    const optionsFormatted = [];
    options.forEach(option => {
      optionsFormatted.push({ value: option, label: option });
    });
    if (otherOption) {
      optionsFormatted.push({
        value: 'Other (Please Specify)',
        label: 'Other (Please Specify)'
      });
    }

    const {
      stretchedDropdown = false,
      customClassOther = 'survey-item-medium'
    } = this.props;
    let containerClassName = '';
    if (this.props.addMoreButton && stretchedDropdown) {
      containerClassName = 'survey-flex-container';
    } else if (this.props.addMoreButton) {
      containerClassName = 'survey-flex survey-flex-low-margin';
    }
    return this.state.formItems.map((item, index) => {
      const showDivider = index > 0;

      return (
        <Fragment key={index}>
          {showDivider && this.props.isMobile ? (
            <hr className="add-more-divider" />
          ) : null}
          <div
            className={
              this.state.isNone
                ? 'survey-is-none survey-flex-container'
                : 'survey-flex-container'
            }
          >
            <div className={containerClassName} key={index}>
              <Flex align="center" key={index}>
                <Select
                  options={optionsFormatted}
                  placeholder={this.props.placeholder || ''}
                  disabled={this.state.isNone}
                  className={`survey-dropdown survey-item-${size}`}
                  onChange={e => this.handleDropdownChange(e, index)}
                  value={this.state.formItems[index].selected}
                  clearable={false}
                  searchable={searchable}
                />
                <div className={`survey-label`}>
                  {index !== 0 ? (
                    <span
                      onClick={e => this.deleteItem(index)}
                      className="del-btn no-style"
                    >
                      Remove {!this.props.isMobile && '×'}
                    </span>
                  ) : null}
                  {label}
                </div>
              </Flex>
            </div>
            {!this.state.formItems[index].hideOther ? (
              <div>
                <div className="survey-placeholder survey-item-medium" />
                <div
                  className={`survey-dropdown-other-container  ${customClassOther}`}
                >
                  <input
                    type="text"
                    placeholder="Type Here..."
                    onChange={e => this.handleTextChange(e, index, 'other')}
                    className={`survey-text`}
                    value={this.state.formItems[index].other}
                  />
                </div>
              </div>
            ) : null}
          </div>
          <Fragment>
            <br />
          </Fragment>
        </Fragment>
      );
    });
  }

  render() {
    const { question, addMoreButton, className } = this.props;

    const UUID = generateUUID();

    return (
      <div className={`${className}`}>
        <Element type="p" fontFamily="GTAM" fontSize="14px">
          {ReactHtmlParser(question)}
        </Element>
        <div className="row surveys-container collapse">
          <div className="surveys-list survey-flex-dropdown small-12 columns">
            {/* addMoreButton && (
              <Fragment>
                <input
                  id={UUID}
                  type="checkbox"
                  checked={this.state.isNone}
                  onClick={() =>
                    this.setState(
                      prevState => {
                        return {
                          isNone: !prevState.isNone,
                          changedState: true
                        }
                      },
                      () => {
                        this.props.storeAnswer(this.props.index, this.state)
                        this.props.checkSurveyState(this)
                      }
                    )
                  }
                />
                <label htmlFor={UUID} className="survey-none-radio">
                  None
                </label>
              </Fragment>
            ) */}
            {/*! this.props.isMobile && addMoreButton ? (
              <Fragment>
                <br />
                <br />
                <br />
              </Fragment>
            ) : null */}

            {this.renderFormItems()}
            {addMoreButton ? (
              <Fragment>
                <div className={this.state.isNone ? 'survey-is-none' : ''}>
                  <div className="survey-add-more-btn" onClick={this.onAddMore}>
                    + {addMoreButton.message}
                  </div>
                </div>

                {!this.props.isMobile && (
                  <Fragment>
                    <br />
                  </Fragment>
                )}

                {this.props.isMobile && (
                  <Fragment>
                    <br />
                    <br />
                    <br />
                    <br />
                  </Fragment>
                )}
              </Fragment>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default Dropdown;
